import { render } from "./ProductGallary.vue?vue&type=template&id=31ef600a&scoped=true"
import script from "./ProductGallary.vue?vue&type=script&lang=js"
export * from "./ProductGallary.vue?vue&type=script&lang=js"

import "./ProductGallary.vue?vue&type=style&index=0&id=31ef600a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ef600a"]])

export default __exports__